import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image-upload-manager" }
const _hoisted_2 = { class: "image-thumbnails-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.images.length > 0)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0 pa-0 mb-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "ma-0 pa-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `img-${index}`,
                      class: "image-thumbnail-wrapper"
                    }, [
                      _createElementVNode("img", {
                        src: image.preview,
                        alt: image.fileName,
                        class: "image-thumbnail"
                      }, null, 8, _hoisted_3),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-close-circle",
                        size: "x-small",
                        class: "delete-image-btn",
                        onClick: ($event: any) => (_ctx.removeImage(index)),
                        variant: "text",
                        color: "error",
                        disabled: _ctx.disabled
                      }, null, 8, ["onClick", "disabled"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "hiddenFileInput",
      type: "file",
      accept: "image/jpeg,image/png,image/gif,image/webp",
      multiple: "",
      style: {"display":"none"},
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileInputChange && _ctx.handleFileInputChange(...args))),
      disabled: _ctx.disabled
    }, null, 40, _hoisted_4)
  ]))
}